export default "__VITE_ASSET__bc890988__"